export function isLast(selected, manual_action_executions) {
  return selected.index === manual_action_executions.length - 1
}

export function getActionName(selected) {
  return (
    selected.trigger_type === 'pre' &&
    selected.action_type === 'check_requirements'
  )
}
